var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { MarkdownEmbed } from './markdown-embed';
// composes MarkdownEmbed above to look for the entity in the embed set under fieldName, and render using the renderer prop
export var createEmbed = function (fieldName, renderer, attr) {
  if (attr === void 0) {
    attr = function (p) {};
  }
  return function (props) {
    return React.createElement(MarkdownEmbed, __assign({}, props, {
      attr: attr,
      fieldName: fieldName,
      component: renderer
    }));
  };
};